module.exports = __webpack_public_path__ + "static/pi3-5ff7767ddd0bc0c88351908a573c7c4c.png";